// see 'https://10.0.0.44/svn/CheetahPlatform/docs/%E9%85%8D%E7%BD%AE%E8%AE%BE%E8%AE%A1/bpm-flow.yaml';

import _ from 'lodash';
import axios from 'axios';
import {WARN_UNDEFINED_TASK_UNIT_TYPE} from './constants';

import testApi from './process';
const { getCanRejectTo } = testApi;

const uri = window.$servicePath+'/rest/process/task';

export async function getTaskFlow({taskId, flowId, groupId, $form}){

  if(!taskId)
    throw 'you need a taskId to get task-flow';

  const params = $form;
  let t = Date.now(); //流向条件设置表单的值切换IE上有缓存问题，所以加t
  if(!flowId)
    return axios.get(`${uri}/flow/${taskId}?t=${t}`, {params}).then(response=>response.data)
    .then(data=>{
      //console.log(`%c-- inject task flow cat prop for development --`, 'color: orange');
      return _.map(data, flow=>{
        if(_.isUndefined(flow.cat)){
          flow.cat = 'to-next';
        }
        return flow;
      })
    });
    // .then(()=>{
    //   console.log(`%c-- inject task flow data for develop --`, 'color: orange');
    //   return [
    //     {
    //       "id":"task01_task02","activityId":"task02","name":"送部门领导审核","type":"basic",
    //       "cat":"to-next",
    //       "options":{"selectUnit":"user","activityUnit":"group","sendDirectly":false,"multipleUnit":true}
    //     },
    //     {
    //       "id":"task01_task03","activityId":"task02","name":"送部门领导审核2","type":"basic",
    //       "cat":"to-next",
    //       "options":{"selectUnit":"user","activityUnit":"group","sendDirectly":false,"multipleUnit":true}
    //     },
    //     {
    //       "id":"task01_task04","activityId":"task02","name":"送会签","type":"basic",
    //       "cat":"fork",
    //       "options":{"selectUnit":"user","activityUnit":"group","sendDirectly":false,"multipleUnit":true}
    //     },
    //     {
    //       "id":"task01_task05","activityId":"task02","name":"送会签2","type":"basic",
    //       "cat":"fork",
    //       "options":{"selectUnit":"user","activityUnit":"group","sendDirectly":false,"multipleUnit":true}
    //     },
    //   ]
    // });

  if(!groupId)
    return axios.get(`${uri}/flow/${taskId}/${flowId}`, {params}).then(response=>response.data)
    // .then(()=>{
    //   console.log(`%c-- inject fetch flow for develop --`, 'color: orange');
    //   return [
    //     {"id":"org01","name":"广州美络"},
    //     {"id":"org01-03/org01","name":"项目开发部"},
    //     {"id":"org001/org01-03/org01","name":"核心产品组"},
    //     {"id":"org002/org01-03/org01","name":"测试组"},
    //     {"id":"org02","name":"北京美络"},
    //     {"id":"org01-04/org02","name":"协同项目部"},
    //   ]
    // });

  return axios.get(`${uri}/flow/${taskId}/${flowId}/${groupId}`, {params})
    .then(response=>response.data)
    // .catch(_=>undefined)
    // .then(()=>{
    //   console.log(`%c-- inject fetch group for develop --`, 'color: orange');
    //   return _.sampleSize([
    //     {"id":"user05","name":"用户05","type":"U"},
    //     {"id":"user06","name":"用户06","type":"U"},
    //     {"id":"user07","name":"用户07","type":"U"},
    //     {"id":"user08","name":"用户08","type":"U"},
    //     {"id":"user09","name":"用户09","type":"U"},
    //   ], 2)
    // })
    .then(data=>{               // transform to {users:Array} or {positions:Array} by type property
      const keyMap = new Map([['U', 'users'],['P', 'positions']]);
      return _.groupBy(data, ({type})=>keyMap.get(type));
    }).then(data=>{
      if(data[undefined]){
        
      }
      return data;
    });
}

export function getTaskPrevious(taskId){

  if(!taskId)
    throw 'you need a taskId to get previous tasks';

    return axios.get(`${uri}/previous/${taskId}`).then(response=>response.data)
}



// WEBPACK FOOTER //
// ./src/common/api/bpm-task.js